export const aboutInfo = {
  brandName: '掌中之物',
  tagline: '方寸之间，无限魅力',
  founded: 2015,
  description: '「掌中之物」成立于2015年，是一家专注于精品收藏的文化品牌。我们相信，真正美好的事物值得被双手珍视，值得被用心感受。从文玩把件到工艺摆件，从茶器茶具到收藏精品，每一件掌中之物都承载着匠人的心血与岁月的温度。',
  mission: '我们致力于发现和传递那些值得被双手珍视的美好，让每一件掌中之物都成为你生活中不可或缺的一部分。在方寸之间，感受东方美学的无限魅力。',
  values: [
    {
      title: '品质至上',
      description: '每一件精品都经过严格的选材和工艺把关，确保您拿到的是真正值得收藏的佳作。',
      icon: 'ri-star-line',
    },
    {
      title: '匠心传承',
      description: '我们与数十位手工艺人深度合作，守护和传承那些正在消失的传统手工艺。',
      icon: 'ri-hand-heart-line',
    },
    {
      title: '文化传播',
      description: '通过内容与产品，让更多人了解和爱上中国传统文化的精髓与美好。',
      icon: 'ri-lightbulb-line',
    },
    {
      title: '真诚服务',
      description: '每一位客户都是我们的朋友，我们用心倾听、真诚对待，让购物成为愉快的体验。',
      icon: 'ri-user-smile-line',
    },
  ],
  reputation: [
    {
      name: '张文远',
      title: '资深收藏家',
      content: '掌中之物的每件作品都透着匠人的用心，从选材到工艺都无可挑剔。我在这买了三年，每次都有惊喜。',
      rating: 5,
      date: '2026-07-15',
    },
    {
      name: '李晓华',
      title: '茶文化爱好者',
      content: '在掌中之物买了一把紫砂壶，泡养了半年，已经温润如玉。客服还耐心教我养护方法，非常感动。',
      rating: 5,
      date: '2026-06-28',
    },
    {
      name: '王思远',
      title: '企业管理者',
      content: '送给客户的礼物都在掌中之物挑选，每次都能收到客户的真诚感谢。品质和包装都是一流的。',
      rating: 5,
      date: '2026-06-10',
    },
    {
      name: '赵雅琳',
      title: '文玩爱好者',
      content: '入坑文玩一年，掌中之物的文章和产品让我少走了很多弯路。推荐给所有想入门的朋友。',
      rating: 5,
      date: '2026-05-22',
    },
    {
      name: '刘建国',
      title: '美术教师',
      content: '作为一名美术老师，我对工艺品的审美要求很高。掌中之物的选品眼光让我非常认可，每一件都是艺术品。',
      rating: 5,
      date: '2026-05-08',
    },
    {
      name: '周小燕',
      title: '礼品采购经理',
      content: '我们公司的商务礼品都是从这里采购的，品质稳定，包装精美，物流也很靠谱，合作非常愉快。',
      rating: 5,
      date: '2026-04-20',
    },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    phone: '400-888-6666',
    email: 'service@zhangzhongzhiwu.com',
    wechat: 'zhangzhongzhiwu',
    businessHours: '周一至周五 09:00 - 18:00',
  },
};